import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MediaService } from '@core/services/media.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { BillingOverviewModel } from '@shared/models/billing.model';

@Component({
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule
    ],
    selector: 'sfx-pricing-switch',
    templateUrl: './pricing-switch.component.html',
    styleUrls: ['./pricing-switch.component.scss']
})
export class PricingSwitchComponent implements OnInit {

    @Input() options: BillingOverviewModel;

    @Input() selectedValue: string;
    @Output() selectedValueChange: EventEmitter<string> = new EventEmitter<string>();

    @Input() editPlan: boolean;
    @Input() fromBilling?: boolean;

    constructor(
        public media: MediaService,
        private translate: TranslateService
    ) {}

    public ngOnInit(): void {}

    public setValue(value: string): void {

        this.selectedValue = value;
        this.selectedValueChange.emit(value);
    }

    getUsersText(): string {
        const count = this.options.quantity;
        if (count === 1) {
            return this.translate.instant('1 user');
        }

        return count + ' ' + this.translate.instant('users');
    }

    getUserMonthText(): string {
        return this.translate.instant('user/month');
    }

    getYearForText(): string {
        return this.translate.instant('/year for') + ' ' + this.getUsersText();
    }

    getMonthForText(): string {
        return this.translate.instant('/month for') + ' ' + this.getUsersText();
    }
}
